import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyStockExchangesDto } from '../../models/api/companyStockExchangesDto';
import { UpsertCompanyStockExchangesRequest } from '../../models/api/upsertCompanyStockExchangesRequest';

@Injectable({
  providedIn: 'root'
})
export class CompanyStockExchangesService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<CompanyStockExchangesDto> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<CompanyStockExchangesDto>(`${this.apiUrl}/${companyId}/stock-exchanges`, { params });
  }

  upsert(companyId: string, request: UpsertCompanyStockExchangesRequest): Observable<CompanyStockExchangesDto> {
    return this.http.put<CompanyStockExchangesDto>(`${this.apiUrl}/${companyId}/stock-exchanges`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/stock-exchanges`, { params });
  }
}
